/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Hls_Manifest_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Manifest URL" |
*
* @param {New_Project_Hls_Manifest_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_hls_manifest_placeholder = /** @type {((inputs?: New_Project_Hls_Manifest_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Hls_Manifest_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL du manifeste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Manifest-URL")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL manifesto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("URL манифеста")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL del manifiesto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清单网址")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マニフェストURL")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मैनिफेस्ट यूआरएल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("URL do manifesto")
	return /** @type {LocalizedString} */ ("Manifest URL")
});